// extracted by mini-css-extract-plugin
export default {"argumentsBox":"IntegrationArguments_argumentsBox__LjUFN","argument":"IntegrationArguments_argument__wlXP7"};